/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum ApplicationContainerDataKey {
  /**
   * Carousel ID where the content or link to collection is located
   */
  CONTAINER_ID = 'container_id',
  /**
   * Carousel where the content or link to collection is located
   */
  CONTAINER_NAME = 'container_name',
}
